import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

function RolGuard({ children }) {
    const account = useSelector((state) => state.account);

    if (!account.user) {
        return <Redirect to="/login" />;
    }
    else if (account.user.user.rolId !== 1) {
        return <Redirect to="/login" />;
    }

    return children;
}

RolGuard.propTypes = {
    children: PropTypes.any
};

export default RolGuard;